/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * What the person sees after the test. NONE — the result only. MISTAKES — the questions answered wrong, with the right answers. MISTAKES_WITH_EXPLANATIONS — the same with the explanations the bank holds.
 * @export
 * @enum {string}
 */

export const MistakeReviewDto = {
    None: 'NONE',
    Mistakes: 'MISTAKES',
    MistakesWithExplanations: 'MISTAKES_WITH_EXPLANATIONS'
} as const;

export type MistakeReviewDto = typeof MistakeReviewDto[keyof typeof MistakeReviewDto];



